"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFloatingToolbarState = exports.useFloatingToolbar = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _slateReact = require("slate-react");
var _index = require("../index");
var useFloatingToolbarState = function useFloatingToolbarState(_ref) {
  var editorId = _ref.editorId,
    floatingOptions = _ref.floatingOptions,
    focusedEditorId = _ref.focusedEditorId,
    hideToolbar = _ref.hideToolbar,
    ignoreReadOnly = _ref.ignoreReadOnly;
  var selectionExpanded = (0, _plateCommon.useEditorSelector)(_plateCommon.isSelectionExpanded, []);
  var selectionText = (0, _plateCommon.useEditorSelector)(_plateCommon.getSelectionText, []);
  var focused = (0, _slateReact.useFocused)();
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    open = _react$default$useSta2[0],
    setOpen = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    waitForCollapsedSelection = _react$default$useSta4[0],
    setWaitForCollapsedSelection = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState(false),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    mousedown = _react$default$useSta6[0],
    setMousedown = _react$default$useSta6[1];
  var floating = (0, _index.useVirtualFloating)((0, _plateCommon.mergeProps)({
    getBoundingClientRect: _index.getSelectionBoundingClientRect,
    onOpenChange: setOpen,
    open: open
  }, floatingOptions));
  return {
    editorId: editorId,
    floating: floating,
    focused: focused,
    focusedEditorId: focusedEditorId,
    hideToolbar: hideToolbar,
    ignoreReadOnly: ignoreReadOnly,
    mousedown: mousedown,
    open: open,
    selectionExpanded: selectionExpanded,
    selectionText: selectionText,
    setMousedown: setMousedown,
    setOpen: setOpen,
    setWaitForCollapsedSelection: setWaitForCollapsedSelection,
    waitForCollapsedSelection: waitForCollapsedSelection
  };
};
exports.useFloatingToolbarState = useFloatingToolbarState;
var useFloatingToolbar = function useFloatingToolbar(_ref2) {
  var _selectionText$length;
  var editorId = _ref2.editorId,
    floating = _ref2.floating,
    focusedEditorId = _ref2.focusedEditorId,
    hideToolbar = _ref2.hideToolbar,
    ignoreReadOnly = _ref2.ignoreReadOnly,
    mousedown = _ref2.mousedown,
    open = _ref2.open,
    selectionExpanded = _ref2.selectionExpanded,
    selectionText = _ref2.selectionText,
    setMousedown = _ref2.setMousedown,
    setOpen = _ref2.setOpen,
    setWaitForCollapsedSelection = _ref2.setWaitForCollapsedSelection,
    waitForCollapsedSelection = _ref2.waitForCollapsedSelection; // On refocus, the editor keeps the previous selection,
  // so we need to wait it's collapsed at the new position before displaying the floating toolbar.
  _react.default.useEffect(function () {
    if (!(editorId === focusedEditorId) || ignoreReadOnly) {
      setWaitForCollapsedSelection(true);
    }
    if (!selectionExpanded) {
      setWaitForCollapsedSelection(false);
    }
  }, [editorId, focusedEditorId, ignoreReadOnly, selectionExpanded, setWaitForCollapsedSelection]);
  _react.default.useEffect(function () {
    var mouseup = function mouseup() {
      return setMousedown(false);
    };
    var mousedown = function mousedown() {
      return setMousedown(true);
    };
    document.addEventListener('mouseup', mouseup);
    document.addEventListener('mousedown', mousedown);
    return function () {
      document.removeEventListener('mouseup', mouseup);
      document.removeEventListener('mousedown', mousedown);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  _react.default.useEffect(function () {
    if (!selectionExpanded || !selectionText || mousedown && !open || hideToolbar) {
      setOpen(false);
    } else if (selectionText && selectionExpanded && !waitForCollapsedSelection) {
      setOpen(true);
    }
  }, [setOpen, editorId, focusedEditorId, hideToolbar, ignoreReadOnly, selectionExpanded, selectionText, mousedown, waitForCollapsedSelection, open]);
  var update = floating.update;
  var selectionTextLength = (_selectionText$length = selectionText === null || selectionText === void 0 ? void 0 : selectionText.length) !== null && _selectionText$length !== void 0 ? _selectionText$length : 0;
  _react.default.useEffect(function () {
    if (selectionTextLength > 0) {
      update === null || update === void 0 ? void 0 : update();
    }
  }, [selectionTextLength, update]);
  return {
    hidden: !open,
    props: {
      style: floating.style
    },
    ref: floating.refs.setFloating
  };
};
exports.useFloatingToolbar = useFloatingToolbar;